import { accountsFilterAtom } from 'atoms/filters/rsim-products';
import { FilterAsyncChip } from 'common/components/FilterChip/FilterAsyncChip';
import { FilterChip } from 'common/components/FilterChip/FilterChip';
import { useAtom } from 'jotai';
import { fetchAccount } from 'common/components/Filters/Inputs/accounts/api/accounts';

export const RSimAccountChips = () => {
  const [accounts, setAccounts] = useAtom(accountsFilterAtom);

  const onClear = (id: string | null) => {
    setAccounts((currentAccounts) => currentAccounts.filter((account) => account !== id));
  };

  if (accounts.length === 0) {
    return null;
  }

  return (
    <>
      {accounts.map((account) => {
        if (account === null) {
          return (
            <FilterChip
              key={account}
              text="Account: blank"
              onClose={() => {
                onClear(account);
              }}
            />
          );
        }

        return (
          <FilterAsyncChip
            key={account}
            labelPrefix="Account"
            onCancel={() => {
              onClear(account);
            }}
            fieldName="accountName"
            queryFn={() => {
              return fetchAccount(account);
            }}
            queryKey={['account', account]}
            queryEnabled={!!account}
          />
        );
      })}
    </>
  );
};
